module.exports = __webpack_public_path__ + "img/onlinePlatformBg-sm.30c7d82c.jpg";